import Backbone from "backbone";
import _ from "underscore";

const ConsumerTokenModel = Backbone.Model.extend({
    initialize(attributes, options) {
        this.email = options.email;
        this.defaultDomain = options.defaultDomain;
    },

    url() {
        return new URL(`/api/v5/token`, `https://${this.defaultDomain}`);
    },
    sync(method, model, options) {
        if (method === "create") {
            options.attrs = _.extend(this.attributes, {
                email: this.email,
            });
        }
        return Backbone.sync.call(this, method, model, options);
    },
});

export default ConsumerTokenModel;
